import { Box } from "@mui/material";
import MediaGallery from "@/modules/property-tracks/components/documents-tab/media-gallery";
import { useTrackDocumentQuery } from "@/modules/property-tracks/hooks/track-document.hook";

interface ListingsImagesProps {
  trackUid?: string;
}

export const ListingImages = ({ trackUid }: ListingsImagesProps) => {
  // Fetch pre-signed URLs for track documents
  const { data: presignedDocuments, isLoading: isLoadingPresigned } =
    useTrackDocumentQuery({
      uid: trackUid,
      documentType: "Media",
    });

  // Extract pre-signed image URLs for MediaGallery
  const imageUrls = presignedDocuments?.map((doc) => doc.fileUrl) || [];

  return (
    <Box sx={{ width: "100%" }}>
      <MediaGallery data={imageUrls} isLoading={isLoadingPresigned} />
    </Box>
  );
};
